import useDeleteAddressModals from './useDeleteAddressModals'
import DeleteAddressBlockedModal from './DeleteAddressBlockedModal'
import DeleteAddressConfirmModal from './DeleteAddressConfirmModal'

const DeleteAddressModals = () => {
  const {
    deleteAddressModal,
    deleteAddressBlockedModal,
    deleteAddressIsLoading,
    closeBlockedModal,
    closeConfirmModal,
    handleConfirmDelete,
  } = useDeleteAddressModals()

  return (
    <>
      <DeleteAddressBlockedModal isOpen={deleteAddressBlockedModal} onClose={closeBlockedModal} />
      <DeleteAddressConfirmModal
        isOpen={deleteAddressModal}
        isLoading={deleteAddressIsLoading}
        onClose={closeConfirmModal}
        onConfirm={handleConfirmDelete}
      />
    </>
  )
}

export default DeleteAddressModals
